import { hoc } from '@/util';
import * as stateManagement from '@/stateManagement';

const mapDispatchToProps = {
  openHelpCenter: stateManagement.panels.actions.openHelpCenter,
};

export default hoc.connect(hoc.STORES.EDITOR_API, null, mapDispatchToProps);
